<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useI18n } from 'vue-i18n'
import ConfirmDialog from 'primevue/confirmdialog'
import Toast from 'primevue/toast'

const { t } = useI18n()

const toastBreakpoints = {
  '480px': {
    width: 'calc(100vw - 2rem - var(--safe-area-left) - var(--safe-area-right))',
    left: 'calc(1rem + var(--safe-area-left))',
    right: 'calc(1rem + var(--safe-area-right))',
  },
}
</script>

<template>
  <div class="min-h-screen">
    <!-- Skip to main content link for keyboard users -->
    <a href="#main-content" class="skip-link">
      {{ t('common.skipToContent') }}
    </a>
    <div id="main-content" tabindex="-1">
      <RouterView />
    </div>

    <!-- Global PrimeVue components -->
    <ConfirmDialog />
    <Toast :breakpoints="toastBreakpoints" />
  </div>
</template>

<style scoped>
/* App-specific styles */
</style>
